import { createAction } from '@reduxjs/toolkit';
import { PersonalDevelopmentPlan } from 'types/pdp';

export const setFullData =
  createAction<PersonalDevelopmentPlan>('pdp/setFullData');
